<template>
	<div class="main">
		<list-renderer :apiUrl="'/api/' + $selectedSite.slug + '/providerlister'" :filterIn="filterIn" :listInData="'allProviders'" :orderBy="orderBy" :orderByRules="orderByRules">
			<template #header="{title}">
				<h2>Provider Lister</h2>
			</template>
			<template #content='{list,rawData}'>

				<div class="table-responsive">
					<table>
						<thead>
							<tr>
								<th>Provider Name</th>
								<th>Slug</th>
								<th>Type</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="provider in list">
								<td>{{ provider.name }}
									<span class="badge badge-warning" title="Pending change requests" v-if="rawData.hasOwnProperty(pendingRequests) && rawData.pendingRequests.hasOwnProperty(provider.id)">{{rawData.pendingRequests[provider.id]}}</span>
								</td>
								<td>{{ provider.slug }}</td>
								<td>{{ provider.providerType }}</td>
								<td class="nowrap">
									<a :href="'/' + selectedSite.slug + '/providers/' + provider.id + '/edit?tab=general'" class="btn btn-icon btn-primary" title="Edit" v-show="userRoles.includes('providers.update')"><i class="fas fa-pencil-alt"></i></a>
									<a :href="'/' + selectedSite.slug + '/providers/' + provider.id + '/review?tab=content'" class="btn btn-icon btn-primary" title="Edit Review" v-show="userRoles.includes('providers.edit-review') && provider.has_review"><i class="fas fa-edit"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-renderer>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				userRoles: this.$currentUserRoles,
				selectedSite: this.$selectedSite,
				filterIn: ['name', 'slug', 'providerType'],
				orderBy: ['pendingRequests', 'name'],
				orderByRules: ['desc', 'asc'],
			}
		},
		methods: {}
	}
</script>

<style scoped>

</style>
